<template>
  <v-flex xs12>
    <v-card class="py-4">
      <v-flex xs12 pb-3 px-4 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 px-4 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-flex xs12 sm10 md7 lg5 class="px-4">
          <v-autocomplete
            :items="companies"
            :label="$lang.actions.selectCompany"
            :readonly="isEdit"
            v-model="companyId"
            item-text="name"
            item-value="id"
            required
            :loading="companyLoading"
            :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
          />
        </v-flex>
        <v-btn class="primary mx-4" @click="addMapping" :disabled="editingMap">{{$lang.actions.addLangMapp}}</v-btn>
        <div class="v-table__overflow my-3 px-4">
          <table class="v-datatable v-table theme--light">
            <tbody>
              <tr
                v-for="(map, index) in maps"
                :key="index">
                <template v-if="map.isEdit">
                  <td>
                    <v-select
                      class="min-w"
                      required
                      :items="printerCategories"
                      v-model="tempMapping.categoryName"
                      :label="$lang.actions.selectPrinterCategory" />
                  </td>
                  <td>
                    <v-select
                      class="min-w"
                      required
                      :items="languages"
                      item-text="text"
                      item-value="value"
                      v-model="tempMapping.language"
                      :label="$lang.actions.selectLanguage" />
                  </td>
                  <td class="min-w-lg px-0">
                    <v-btn class="primary elevation-1" :disabled="!tempMapping.language || !tempMapping.categoryName" @click="saveMappingEdit(map)">{{$lang.actions.save}}</v-btn>
                    <v-btn class="error ml-0 elevation-1" @click="closeMappingEdit(map)">{{$lang.actions.cancel}}</v-btn>
                  </td>
                </template>
                <template v-else>
                  <td>{{ map.categoryName }}</td>
                  <td>{{ map.language }}</td>
                  <td class="actions px-0">
                    <v-btn class="primary elevation-1" @click="editMapping(map)">{{$lang.actions.edit}}</v-btn>
                    <v-btn class="error ml-0 elevation-1" @click="deleteMapping(index)">{{$lang.actions.delete}}</v-btn>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <v-layout row wrap justify-space-between class="px-2">
          <v-text-field
            v-if="isEdit && createdOn"
            :label="$lang.labels.created"
            v-model="createdOn"
            readonly
            class="min-w max-w mx-3"
          />
          <v-text-field
            v-if="isEdit && modifiedOn"
            :label="$lang.labels.modified"
            v-model="modifiedOn"
            readonly
            class="min-w max-w mx-3"
          />
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="px-2">
          <v-btn
            flat class="mx-3"
            @click="$router.push({ name: 'languageMappings' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <v-btn
            class="primary mx-3"
            :disabled="!valid"
            @click="submit">
            {{ isEdit ? $lang.actions.update : $lang.actions.create}}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      printerCategories: [],
      companyId: null,
      maps: [],
      tempMapping: {
        categoryName: '',
        language: '',
      },
      editingMap: false,
      languages: JSON.parse(localStorage.languages),
      createdOn: '',
      modifiedOn: '',
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      addMapping() {
        this.maps.push({
          categoryName: '',
          language: '',
          isEdit: true,
        });
        this.editingMap = true;
        this.$forceUpdate();
      },
      editMapping(map) {
        this.tempMapping = {
          categoryName: map.categoryName,
          language: map.language,
        };
        this.$set(map, 'isEdit', true);
        this.editingMap = true;
      },

      deleteMapping(index) {
        this.maps.splice(index, 1);
        this.$forceUpdate();
      },

      saveMappingEdit(map) {
        this.$set(map, 'categoryName', this.tempMapping.categoryName);
        this.$set(map, 'language', this.tempMapping.language);
        this.closeMappingEdit(map);
      },

      closeMappingEdit(map) {
        this.tempMapping = {
          categoryName: '',
          language: '',
        };
        this.$set(map, 'isEdit', false);
        this.editingMap = false;
      },

      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });

          this.$http.get('printer/fetchprintercategories')
            .then((res) => {
              resolve()
              if (res.body.status === 'Success') {
                this.printerCategories = res.body.printerCategories;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      submit() {
        if (this.maps.length === 0) {
          this.err = 'You must add at least one language mapping';
          return;
        }
        const data = {
          companyId: this.companyId,
          mapping: {},
        };
        this.maps.forEach(map => data.mapping[map.categoryName] = map.language);
        let url = this.isEdit ? `printercategory/update/${this.$route.params.id}` : 'printercategory/create';
        this.$http.post(url, data)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'Language Mapping updated successfuly' : 'Language Mapping created successfuly';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({ name: 'languageMappings' });
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.init()
        .then(() => {
          if (this.$route.params.id) {
            this.isEdit = true;
            this.$http.get(`printercategory/${this.$route.params.id}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  const data = res.body.details;
                  this.companyId = data.companyId;
                  this.createdOn = this.formatDate(data.createdOn);
                  if (data.modifiedOn) {
                    this.modifiedOn = this.formatDate(data.modifiedOn);
                  }
                  this.maps = Object.keys(data.mapping).map(key => ({
                    categoryName: key,
                    language: data.mapping[key],
                    isEdit: false,
                  }));
                  this.$forceUpdate();
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
            }
        })
    },
  };
</script>

<style lang="scss" scoped>
  tr {
    &:nth-of-type(odd){
      background-color: #f9f9f9;
    }
  }
  td {
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// LanguageMappingDetails.vue?302b02c6